module.exports = __webpack_public_path__ + "img/barcodeprinter.59f6bd81.png";